import api from './api';

export const faqApi = {
  // FAQ 생성
  createFaq: async (data) => {
    const response = await api.post('/faq/curated-answers', data);
    return response.data;
  },

  // FAQ 목록 조회
  listFaqs: async (params = {}) => {
    const response = await api.get('/faq/curated-answers', { params });
    return response.data;
  },

  // FAQ 상세 조회
  getFaq: async (id) => {
    const response = await api.get(`/faq/curated-answers/${id}`);
    return response.data;
  },

  // FAQ 수정
  updateFaq: async (id, data) => {
    const response = await api.put(`/faq/curated-answers/${id}`, data);
    return response.data;
  },

  // FAQ 삭제
  deleteFaq: async (id) => {
    const response = await api.delete(`/faq/curated-answers/${id}`);
    return response.data;
  },

  // FAQ 검색
  searchFaqs: async (data) => {
    const response = await api.post('/faq/curated-answers/search', data);
    return response.data;
  },

  // 카테고리 목록 조회
  getCategories: async () => {
    const response = await api.get('/faq/categories');
    return response.data;
  }
}; 